/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'light': {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    data: '<circle pid="0" cx="12" cy="12" r="5"/><path pid="1" d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>'
  }
})
